import React from 'react';
import { ChatScreen } from '../shared/ChatScreen';

interface DoctorChatScreenProps {
  onBack?: () => void;
}

export const DoctorChatScreen = ({ onBack }: DoctorChatScreenProps = {}) => {
  return <ChatScreen userRole="DOCTOR" onBack={onBack}  chatUser={null}/>;
};
